import React from 'react';
import { observer } from 'mobx-react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components/macro';

import { useDataStore } from 'state/DataStore';

import Page from 'components/Page';
import InfoBox from 'components/InfoBox';
import InfoBoxHeader from 'components/InfoBox/InfoBoxHeader';
import InfoBoxArea from 'components/InfoBox/InfoBoxArea';
import ImagePopup from 'components/ImagePopup';
import AvailableUnitsBox from 'components/AvailableUnitsBox';

const Floorplan = observer(() => {
    const dataStore = useDataStore();
    const { unitTypeSlug } = useParams();
    const { units } = dataStore.data;
    
    const unitType = dataStore.getItem('unit_types', 'slug', unitTypeSlug);
    
    if (!unitType) {
        return (
            <Page>
                <h1>No Unit Type Found</h1>
            </Page>
        );
    }

    const availableUnits = units.filter(unit => {
        return unit.acf.unit_type === unitType.id && unit.acf.status === 'available';
    });
    
    availableUnits.sort((a, b) => (
        a.title?.rendered?.localeCompare(b.title?.rendered)
    ));

    const areaData = [
        { name: 'Internal', value: `${unitType.acf.internal_area}m<sup>2</sup>` },
        { name: 'External', value: `${unitType.acf.external_area}m<sup>2</sup>` },
        { name: 'Total', value: `${unitType.acf.total_area}m<sup>2</sup>` },
    ];
    
    return (
        <Page>
            <Inner>
                <CenterContent>
                    <PlanImage image={unitType.acf.floorplan} size="main" />

                    <AvailableUnitsBox
                        availableUnits={availableUnits}
                        availableText={`Available apartments for Type ${unitType.title.rendered}`}
                    />

                    <KeyPlanImage src={unitType.acf.key_plan?.sizes?.main} alt="" />

                    <Disclaimer dangerouslySetInnerHTML={{ __html: dataStore.getSetting('apartment_settings', 'unit_disclaimer') }} />
                </CenterContent>

                <InfoBox>
                    <InfoBoxHeader unitType={unitType} />

                    <InfoBoxArea areaData={areaData} roomData={unitType.acf.room_areas} />
                </InfoBox>
            </Inner>
        </Page>
    );
});


export default Floorplan;


const Inner = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
`;

const CenterContent = styled.div`
    position: relative;
    flex: 1 1 auto;
    display: flex;
    padding: 4rem 10rem 20rem;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

const PlanImage = styled(ImagePopup)`
    height: 100%;
    width: 100%;
    object-fit: contain;
`;

const KeyPlanImage = styled.img`
    position: absolute;
    bottom: 2rem;
    right: 5rem;
    height: 19rem;
    width: auto;
`;

const Disclaimer = styled.div`
    position: absolute;
    bottom: 3rem;
    left: 5rem;
    width: 90rem;
    font-size: 1.2rem;
    color: ${props => props.theme.primary_color};
    opacity: .4;

    p {
        margin: 0;
    }
`;

